'use client';
import { getLinkProps } from '@/app/lib';
import { getImageBuilder } from '@/app/lib/media-helper';
import Link from 'next/link';
import { AppImage, Typography } from '@workspace/ui/common';
import type { IHeaderData } from '../interfaces';

interface HeaderLogoProps {
  headerData?: IHeaderData | null;
}

export const Logo = ({ headerData }: HeaderLogoProps) => {
  if (!headerData?.headerLogo) return null;
  const { headerLogo } = headerData;
  const logoSource = headerLogo.bynderLogo || headerLogo.imageUrl;

  const linkProps = getLinkProps(headerLogo.link);
  const logoAlt = headerLogo.bynderLogo?.alt || headerData.title || 'Logo';

  // Ensure href is always defined for Next.js Link
  if (!linkProps.href) {
    return null;
  }

  const logoSrc = logoSource ? getImageBuilder(logoSource).width(126).dpr(1).url() : '';

  return (
    <Link {...linkProps} className="flex items-center mr-25">
      {logoSource ? (
        <div className="relative aspect-[21/5] h-6 sm:h-7.5">
          <AppImage src={logoSrc} alt={logoAlt} className="cursor-pointer" quality={100} fill sizes="126px" />
        </div>
      ) : (
        <Typography variant="h1" className="text-primary-500 font-bold text-2xl">
          porta
        </Typography>
      )}
    </Link>
  );
};
